import React, { useState, useRef } from 'react';
import { __ } from '@wordpress/i18n';

// api
import CompanyService from '../../../../service/company-service';

// components
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

const DownloadSuppliersCsv = () => {
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const downloadSuccessCallback = (resp) => {
        const file = new Blob([resp], { type: 'text/csv' });
        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `fornitori.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);
    }

    const downloadErrorCallback = (resp) => {
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: '',
                detail: resp.message
            });
        }
        setLoading(false);
    }

    const handleDownload = () => {
        setLoading(true);
        CompanyService.getCompanyCsv(downloadSuccessCallback, downloadErrorCallback)
    }

    return (
        <>
            <Toast ref={toast}/>
            <Button
                type="button"
                disabled={loading}
                severity="success"
                onClick={() => handleDownload()}
                label={__('Scarica CSV Fornitori', 'htr')}
                icon="pi pi-download" iconPos="right"/>
        </>
    )
}

export default DownloadSuppliersCsv;
